import React from 'react';
import ReactDOM from 'react-dom';
import { useZIndexContext } from '../../state/ZIndex';
import { StyledPortal } from './Portal.styles';
export function Portal(_a) {
    var children = _a.children, container = _a.container;
    var zIndexCtx = useZIndexContext();
    return ReactDOM.createPortal(React.createElement(StyledPortal, { zIndex: zIndexCtx.value }, children), container || document.body);
}
export default Portal;
//# sourceMappingURL=Portal.js.map